import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 text-sm text-gray-800" }
const _hoisted_2 = { class: "grid gap-3" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "mt-1 block text-xs text-red-700" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "mt-1 block text-xs text-amber-800" }
const _hoisted_7 = { class: "flex justify-end" }
const _hoisted_8 = ["disabled"]

import { ModalComp } from '@/components'

export type OrderBlockingScope = 'commande' | 'groupe'


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderBlockingScopeModal',
  props: {
    isVisible: { type: Boolean },
    bloque: { type: Boolean },
    idCommande: {},
    groupCount: {},
    loading: { type: Boolean }
  },
  emits: ["update:isVisible", "select"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

function selectScope(scope: OrderBlockingScope) {
  emit('select', scope)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ModalComp), {
    "is-visible": _ctx.isVisible,
    title: _ctx.bloque ? 'Bloquer la commande' : 'Débloquer la commande',
    size: "sm",
    "hide-footer": "",
    "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (emit('update:isVisible', $event)))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, " Choisissez le périmètre à " + _toDisplayString(_ctx.bloque ? 'bloquer' : 'débloquer') + ". " + _toDisplayString(_ctx.bloque
            ? 'Le statut précédent sera conservé séparément pour chaque commande.'
            : 'Chaque commande bloquée retrouvera son statut précédent.'), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-left transition-colors hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-50",
            disabled: _ctx.loading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectScope('commande')))
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "block font-semibold text-red-800" }, " Cette commande uniquement ", -1)),
            _createElementVNode("span", _hoisted_4, " Seule la commande #" + _toDisplayString(_ctx.idCommande) + " sera modifiée. ", 1)
          ], 8, _hoisted_3),
          (_ctx.groupCount !== 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-left transition-colors hover:bg-amber-100 disabled:cursor-not-allowed disabled:opacity-50",
                disabled: _ctx.loading,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (selectScope('groupe')))
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "block font-semibold text-amber-900" }, " Toutes les commandes du groupe ", -1)),
                _createElementVNode("span", _hoisted_6, [
                  (_ctx.groupCount && _ctx.groupCount > 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Les " + _toDisplayString(_ctx.groupCount) + " commandes du groupe seront modifiées. ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Chaque commande rattachée au même groupe sera modifiée. ")
                      ], 64))
                ])
              ], 8, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "rounded-lg border border-gray-300 px-4 py-2 text-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
            disabled: _ctx.loading,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:isVisible', false)))
          }, " Annuler ", 8, _hoisted_8)
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-visible", "title"]))
}
}

})